import React from 'react';
import { whyUs } from '../../mock';
import { GitCompare, Clock, BadgeCheck, Sparkles, Gift, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const iconMap = { GitCompare, Clock, BadgeCheck, Sparkles, Gift, BookOpen };

export default function WhyUs() {
  return (
    <section className="relative py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-slate-200 text-xs font-semibold text-emerald-700 uppercase tracking-wider mb-4">Why Loan Alliance</div>
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl text-slate-900 font-bold">Unbiased Comparisons. Real Numbers.</h2>
          <p className="mt-4 text-slate-600">Our editors compare every product on price, features, and fine print — so you avoid the traps and walk away with the best deal.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyUs.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div key={item.title} className="group relative rounded-2xl bg-white border border-slate-200 p-6 lg:p-7 hover:border-emerald-300 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
                <div className="w-12 h-12 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center group-hover:bg-emerald-600 group-hover:border-emerald-600 transition-colors">
                  <Icon className="w-6 h-6 text-emerald-700 group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-slate-900">{item.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{item.desc}</p>
                <div className="absolute top-4 right-4 font-serif-display text-4xl text-emerald-100 group-hover:text-emerald-200 transition-colors">0{i + 1}</div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 rounded-3xl bg-gradient-to-br from-emerald-600 to-teal-700 overflow-hidden relative">
          <div className="absolute inset-0 grid-pattern opacity-20" />
          <div className="relative px-8 py-12 lg:py-16 lg:px-14 grid lg:grid-cols-2 gap-6 items-center">
            <div>
              <h3 className="font-serif-display text-3xl lg:text-4xl text-white font-bold">Ready to Find the Right Financial Product?</h3>
              <p className="mt-3 text-emerald-50">Start comparing loans, credit protection, and wealth builders — all in one place, all free.</p>
            </div>
            <div className="lg:justify-self-end">
              <Link to="/loan">
                <Button className="bg-white text-emerald-700 hover:bg-emerald-50 h-12 px-7 text-base shadow-lg">Start Comparing</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
